module.exports = __webpack_public_path__ + "img/cloud.abe65a7f.png";